import { Component, OnInit } from '@angular/core';
import { StoreService } from './../../../../services/store.service';
import { ApiService } from './../../../../services/api.service';
import { Profil } from './../../../../models/Profil';
import { CommandeService } from './../../../../services/commande.service';
import { SelectItem, Message, ConfirmationService, UIChart } from 'primeng/primeng';
import { CommandeBordereau } from 'src/app/models/CommandeBordereau';
import { CommandeDetail } from 'src/app/models/CommandeDetail';
import { Commande } from 'src/app/models/Commande';
import { ThrowStmt } from '@angular/compiler';
import { ClientsService } from 'src/app/services/reporting/clients.service';
import { LocaliteService } from 'src/app/services/reporting/localites.service';
import { CriteriaData } from 'src/app/models/CriteriaData';
import { ReportingVenteService } from 'src/app/services/reporting/reporting.vente.service';
import { DatePipe } from '@angular/common';
import { ExcelService } from 'src/app/services/Excel.service';

@Component({
  selector: 'app-cashin-cashout',
  templateUrl: './cashin-cashout.component.html',
  styleUrls: ['./cashin-cashout.component.css']
})
export class CashinCashoutComponent implements OnInit {

  titre = 'Cash IN et Cach OUT';
  itemId: any;
  msgs: Message[] = [];

  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  today: any = new Date();

  dataBar: any;
  dataPie: any;

  listMsisdn: SelectItem[] = [];
  listLogin: SelectItem[] = [];
  listRegroupment: SelectItem[] = [];
  listLocalite: SelectItem[] = [];
  listLocalite2: SelectItem[] = [];
  listLocalite3: SelectItem[] = [];
  listLocalite4: SelectItem[] = [];

  selectedCodedz: string;
  selectedSousZone: string;
  selectedSecteur: string;
  selectedLocalitedd: string;
  selectedPdg: string;
  selectedMsisdn: string;
  selectedRegroupement: string;
  datedebut: any = new Date();
  datefin: any = new Date();

  itemsGlobal: any[] = [];

  displayRegroupementDZ:boolean=true;
  displayRegroupementSOUSZONE:boolean=false;
  displayRegroupementSECTEUR:boolean=false;
  displayRegroupementLOCALITE:boolean=false;

  displaychargement:boolean;

  transactioninTotal=0;
  nbtransactioninTotal=0;
  cashincaTotal=0;
  comrevendeurinTotal=0;

  transactionoutTotal=0;
  nbtransactionoutTotal=0;
  cashoutcaTotal=0;
  comrevendeuroutTotal=0;

  transactionTotal=0;
  nbtransactionTotal=0;
  valeurTotal=0;
  comrevendeurTotal=0;

  displayUserPartenaire:boolean;

  constructor(private confirmationService: ConfirmationService,
    private commandeService: CommandeService,
    private datePipe: DatePipe,
    private localiteService: LocaliteService,
    private clientsService: ClientsService,
    private reportingVenteService: ReportingVenteService,
    private excelService: ExcelService,
    private store: StoreService) { }

  ngOnInit() {
    this.loadSelectList();

    this.displayUserPartenaire = false;
    if(this.store.isUserPartenaire) {
      this.displayUserPartenaire = true;
    }

    //this.initChartBarre();
    //this.initChartPie();
  }


  async recherche() {
    if(this.selectedMsisdn === null || this.selectedMsisdn === undefined || this.selectedMsisdn === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un msisdn PDG ' });
      //return;
    }
    if(this.datedebut === null || this.datedebut === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de debut !' });
      return;
    }
    if(this.datefin === null || this.datefin === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de fin !' });
      return;
    }
    
    let criteria: CriteriaData = new CriteriaData();
    criteria.codedz = this.selectedCodedz;
    criteria.souszone = this.selectedSousZone;
    criteria.secteur = this.selectedSecteur;
    criteria.localitedd = this.selectedLocalitedd;
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.regroupement = this.selectedRegroupement;
    criteria.datedebut = this.localeDateString(this.datedebut);
    criteria.datefin = this.localeDateString(this.datefin);
    criteria.horzone = "";
    console.log(JSON.stringify(criteria));

    this.displaychargement=true;
    try {
      this.itemsGlobal = <any>await this.reportingVenteService.venteOmy2(criteria).toPromise();  
    } catch (error) {}
    this.displaychargement=false;

    this.transactioninTotal=0;
    this.nbtransactioninTotal=0;
    this.cashincaTotal=0;
    this.comrevendeurinTotal=0;

    this.transactionoutTotal=0;
    this.nbtransactionoutTotal=0;
    this.cashoutcaTotal=0;
    this.comrevendeuroutTotal=0;

    this.transactionTotal=0;
    this.nbtransactionTotal=0;
    this.valeurTotal=0;
    this.comrevendeurTotal=0;

    this.itemsGlobal.forEach(e => {
      this.transactioninTotal += Number(e.transactionin);
      this.nbtransactioninTotal += Number(e.nbtransactionin);
      this.cashincaTotal += Number(e.cashinca);
      this.comrevendeurinTotal += Number(e.compdgin);
      this.transactionoutTotal += Number(e.transactionout);
      this.nbtransactionoutTotal += Number(e.nbtransactionout);
      this.cashoutcaTotal += Number(e.cashoutca);
      this.comrevendeuroutTotal += Number(e.compdgout);

      this.transactionTotal += Number(e.transaction);
      this.nbtransactionTotal += Number(e.nbtransaction);
      this.valeurTotal += Number(e.valeur);
      this.comrevendeurTotal += Number(e.compdg);

    });

    //console.log('itemsGlobal: ', this.itemsGlobal);

  }


  initChartBarre() {
    this.dataBar = {
      labels: ['Sabalibougou', 'Kalaban coro', 'Maganbougou', 'Hamdalaye', 'Bamako coura', 'ACI200', 'Kalaban coura', 'Sebenicore', 'Sabalibougou', 'Hamdalaye', 'Faladie', 'Sebenicore'],
      datasets: [
          {
              label: 'Vente Zone',
              backgroundColor: '#ff7e33',
              borderColor: '#ff7e33',
              data: [650000, 590000, 800000, 810000, 560000, 550000, 280000, 480000, 400000, 190000, 860000, 270000]
          },
          {
            label: 'Vente Hors Zone',
            backgroundColor: '#42A5F5',
            borderColor: '#42A5F5',
            data: [600000, 630000, 700000, 800000, 460000, 450000, 380000, 580000, 300000, 300000, 960000, 200000]
        }
      ]
    };

  }

  initChartPie() {
      this.dataPie = {
        labels: ['ZONE','HORS_ZONE'],
        datasets: [
            {
                data: [500000, 300000],
                backgroundColor: [
                    "#00A056",
                    "#FFCE56"
                ],
                hoverBackgroundColor: [
                    "#00A056",
                    "#FFCE56"
                ]
            }]
        };
    }


    async loadSelectList() {

      this.displayRegroupementDZ=true;
    this.displayRegroupementSOUSZONE=false;
    this.displayRegroupementSECTEUR=false;
    this.displayRegroupementLOCALITE=false;

      this.listLogin = [];
      if(this.store.isUserPartenaire) {
        this.listLogin.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
        this.selectedPdg = this.store.currentNomPDG;
      } else {
        this.listLogin.push({ label: 'PDG...', value: null });
        try {
          let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
          for (let el of dataRetourPdg) {
            this.listLogin.push({ label: el.login, value: el.login });
          }
        } catch (error) { }
      }
  
      this.listMsisdn = [];
      this.listMsisdn.push({ label: 'Msisdn...', value: null });
  
      this.listRegroupment = [];
      this.listRegroupment.push({ label: 'Niveau...', value: null });
      this.listRegroupment.push({ label: 'DZ', value: 'DZ' });
      this.listRegroupment.push({ label: 'Sous Zone', value: 'SOUSZONE' });
      this.listRegroupment.push({ label: 'Secteur', value: 'SECTEUR' });
      this.listRegroupment.push({ label: 'Code localité', value: 'LOCALITE' });
  
      try {
        this.listLocalite = [];
        this.listLocalite.push({ label: 'DZ...', value: null });
        let dataRetour = <any>await this.localiteService.findCodedz().toPromise();
        for (let el of dataRetour) {
          this.listLocalite.push({ label: el.codedz, value: el.codedz });
        }
      } catch (error) { }
  
      this.listLocalite2 = [];
      this.listLocalite2.push({ label: 'Sous zone...', value: null });
      this.listLocalite3 = [];
      this.listLocalite3.push({ label: 'Secteur...', value: null });
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
  
    }

    async onChangeRegroupement(event) {
      console.log("event======="+event);
      if(event === 'SOUSZONE'){
        this.displayRegroupementDZ=false;
        this.displayRegroupementSOUSZONE=true;
        this.displayRegroupementSECTEUR=false;
        this.displayRegroupementLOCALITE=false;
      } else if(event === 'SECTEUR'){
        this.displayRegroupementDZ=false;
        this.displayRegroupementSOUSZONE=false;
        this.displayRegroupementSECTEUR=true;
        this.displayRegroupementLOCALITE=false;
      } else if(event === 'LOCALITE'){
        this.displayRegroupementDZ=false;
        this.displayRegroupementSOUSZONE=false;
        this.displayRegroupementSECTEUR=false;
        this.displayRegroupementLOCALITE=true;
      } else {
        this.displayRegroupementDZ=true;
        this.displayRegroupementSOUSZONE=false;
        this.displayRegroupementSECTEUR=false;
        this.displayRegroupementLOCALITE=false;
      } 
    }
  
    async onChangeLocalite(event) {
      this.listLocalite2 = [];
      this.listLocalite2.push({ label: 'Sous zone...', value: null });
      let dataRet = <any>await this.localiteService.findCodeSousZone(event).toPromise();
      for (let el of dataRet) {
        this.listLocalite2.push({ label: el.codeSousZone, value: el.codeSousZone });
      }
      this.listLocalite3 = [];
      this.listLocalite3.push({ label: 'Secteur...', value: null });
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
    }
    async onChangeLocalite2(event) {
      this.listLocalite3 = [];
      this.listLocalite3.push({ label: 'Secteur...', value: null });
      let dataRet = <any>await this.localiteService.findCodeSecteur(event).toPromise();
      for (let el of dataRet) {
        this.listLocalite3.push({ label: el.codeSecteur, value: el.codeSecteur });
      }
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
    }
  
    async onChangeLocalite3(event) {
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
      let dataRet = <any>await this.localiteService.findCodeLocalitedd(event).toPromise();
      for (let el of dataRet) {
        this.listLocalite4.push({ label: el.codeLocalitedd + ' - ' + el.localitedd, value: el.localitedd });
      }
    }
  
    async onChangePDG(event) {
      this.listMsisdn = [];
      this.listMsisdn.push({ label: 'Msisdn...', value: null });
      let dataRet = <any>await this.clientsService.findByLogin(event).toPromise();
      for (let el of dataRet) {
        this.listMsisdn.push({ label: el.telephone, value: el.telephone });
      }
    }
  
  
    localeDateString(val: any): any {
      if (val === null || val === undefined) {
        return null;
      }
      if (typeof val === 'string') {
        return val;
      } else {
        return this.datePipe.transform(val, "dd/MM/yyyy");
      }
    }

    async exporter() {
      if(this.itemsGlobal === null || this.itemsGlobal === undefined) {
        this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
        return;
      }
      if(this.itemsGlobal.length <= 0) {
        this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
        return;
      }
      let listExportXLSX = [];
  
      if(this.displayUserPartenaire) {
        listExportXLSX = [...this.itemsGlobal.map(entry => ({
          "PDG": entry.pdg,

          "MONTANT TRANSACTION CASH-IN": entry.transactionin,
          "NOMBRE TRANSACTION CASH-IN": entry.nbtransactionin,
          "REALISATION CA CASH-IN": entry.cashinca,
          "COMMISSION PDG CASH-IN": entry.compdgin,
          "COMMISSION PDV CASH-IN": entry.comrevendeurin,

          "MONTANT TRANSACTION CASH-OUT": entry.transactionout,
          "NOMBRE TRANSACTION CASH-OUT": entry.nbtransactionout,
          "REALISATION CA CASH-OUT": entry.cashoutca,
          "COMMISSION PDG CASH-OUT": entry.compdgout,
          "COMMISSION PDV CASH-OUT": entry.comrevendeurout

        }))
      ];
      } else {
        listExportXLSX = [...this.itemsGlobal.map(entry => ({
            "PDG": entry.pdg,

            "MONTANT TRANSACTION CASH-IN": entry.transactionin,
            "NOMBRE TRANSACTION CASH-IN": entry.nbtransactionin,
            "REALISATION CA CASH-IN": entry.cashinca,
            "COMMISSION PDG CASH-IN": entry.compdgin,
            "COMMISSION PDV CASH-IN": entry.comrevendeurin,

            "MONTANT TRANSACTION CASH-OUT": entry.transactionout,
            "NOMBRE TRANSACTION CASH-OUT": entry.nbtransactionout,
            "REALISATION CA CASH-OUT": entry.cashoutca,
            "COMMISSION PDG CASH-OUT": entry.compdgout,
            "COMMISSION PDV CASH-OUT": entry.comrevendeurout

          }))
        ];
      }
  
      
      this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.itemsGlobal.length + ' Ligne(s) trouvée(s)' });
    }

}
